import React, { forwardRef } from "react";
import { Button } from "@chakra-ui/react";
import { colours } from "@/utils/themeUtils";

import { ChakraFAIcon } from "@/components/ui/Icon";

interface Props {
	icon: string;
	label: string;
	disabled?: boolean;
	handleClick?: () => void;
	altText?: string;
	iconOnRightSide?: boolean;
	iconColor?: string;
	danger?: boolean;
	testId?: string;
}

export const ActionButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
	const { icon, label, disabled, altText, iconOnRightSide, danger, testId } = props;

	const iconColor = props.iconColor || (danger ? " #B11325" : "#6B778C");
	const textColor = danger ? "#B11325" : colours.navy[800];
	const backgroundColor = danger ? "#FFDBDF" : "white";
	const hoverBackgroundColor = danger ? "#fabec5" : "#F3F5F9";
	const borderColor = danger ? "#B1132522" : "#cdcdcd";

	return (
		<Button
			ref={ref}
			columnGap={3}
			title={altText}
			onClick={props.handleClick}
			py={0}
			border={`1px solid ${borderColor}`}
			rounded={"6px"} // Hack to prevent FZLC Chakra theme in Courses microfrontend from overriding the border radius
			background={backgroundColor}
			color={textColor}
			_hover={{
				background: hoverBackgroundColor,
			}}
			_disabled={{
				bg: "form.disabled.background",
				color: colours.neutrals[300],
				cursor: "not-allowed",
			}}
			isDisabled={disabled}
			data-testid={testId}
		>
			{!iconOnRightSide && <ChakraFAIcon icon={icon} variant="solid" color={iconColor} boxSize={4} />}
			{label}
			{iconOnRightSide && <ChakraFAIcon icon={icon} variant="solid" color={iconColor} boxSize={4} />}
		</Button>
	);
});
